import React, { useEffect, useState } from 'react';
import {
  Dialog,
  Input,
  Button,
  Select,
  Message,
  Card,
  Table,
  NumberPicker,
  Checkbox,
  DatePicker,
} from '@alifd/next';
import { Form } from 'antd';
import moment from 'moment';
import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const { RangePicker } = DatePicker;
const Option = Select.Option;
const CleanPlanList = () => {
  const [form] = Form.useForm();
  const [form1] = Form.useForm();

  const clean = client.service('clean');
  const [cleanDialog, setCleanDialog] = useState(false);
  const [cleanUpdate, setCleanUpdate] = useState({});
  const [communityDeviceStatus, setCommunityDeviceStatus] = useState('insert');
  const [isUpdate, setIsUpdate] = useState(false);
  const [cleanData, setCleanData] = useState([]);
  const [cleanRecordDialog, setCleanRecordDialog] = useState(false);
  const [cleanRecordAddDialog, setCleanRecordAddDialog] = useState(false);

  useEffect(() => {
    clean.find({}).then((result) => {
      setCleanData(result.data);
    });
  }, [isUpdate, clean]);

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 4,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 20,
      },
    },
  };
  const formItemLayoutWithOutLabel = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 20,
        offset: 4,
      },
    },
  };

  const onFinish = (value) => {
    const newCleanObj = {
      ...value,
      cycle: `${value.cleanNum}${value.cleanUnit}`,
      workRecord: [],
      startDate: moment(value.startDate[0]).valueOf(),
      endDate: moment(value.startDate[1]).valueOf(),
    };
    if (communityDeviceStatus === 'insert') {
      clean
        .create(newCleanObj)
        .then(() => {
          Message.success('新增成功');
          setCleanDialog(false);
          setIsUpdate((pre) => !pre);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      clean
        .patch(cleanUpdate._id, newCleanObj)
        .then(() => {
          Message.success('修改成功');
          setCleanDialog(false);
          setIsUpdate((pre) => !pre);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const onFinishRecord = (value) => {
    const newRecordObject = [
      ...cleanUpdate.workRecord,
      {
        ...value,
        createdTime: moment().valueOf(),
      },
    ];
    clean
      .patch(cleanUpdate._id, {
        workRecord: newRecordObject,
      })
      .then(() => {
        Message.success('新增維護記錄成功');
        setIsUpdate((pre) => !pre);
        setCleanRecordAddDialog(false);
        clean
          .find({ query: { _id: cleanUpdate._id } })
          .then((result) => {
            setCleanUpdate(result.data[0]);
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <Button
        onClick={() => {
          setCleanUpdate({});
          setCleanDialog(true);
          setCommunityDeviceStatus('insert');
          form.setFieldsValue({
            cleanNum: 1,
            name: '',
            cleanUnit: '',
            startDate: ['', ''],
            contentText: '',
            weekDate: [],
          });
        }}
      >
        新增清潔工作
      </Button>

      {/* 新增修改年度維護列表 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={cleanDialog}
        onOk={() => {
          form.submit();
        }}
        onCancel={() => {
          setCleanDialog(false);
        }}
        onClose={() => {
          setCleanDialog(false);
        }}
      >
        <h1>{communityDeviceStatus === 'insert' ? '新增' : '修改'}清潔工作</h1>
        <h3>可自行填寫清潔項目或勾選預設項目，並填寫工作週期！！</h3>
        <Form
          form={form}
          name="dynamic_form_item"
          onFinish={onFinish}
          {...formItemLayoutWithOutLabel}
        >
          <Form.Item
            {...formItemLayout}
            rules={[
              {
                required: true,
                message: '請輸入項目名稱',
              },
            ]}
            label="項目名稱"
            name="name"
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="工作頻率"
            required={[{ required: true, message: '請選擇工作頻率' }]}
            {...formItemLayout}
          >
            <div className={styles.workingBox}>
              每
              <Form.Item
                name="cleanNum"
                noStyle
                rules={[
                  {
                    required: true,
                    message: '請選擇天數',
                  },
                ]}
              >
                <NumberPicker min={0} />
              </Form.Item>
              <Form.Item
                noStyle
                name="cleanUnit"
                rules={[
                  {
                    required: true,
                    message: '請選擇時段',
                  },
                ]}
              >
                <Select hasClear placeholder="請選擇時段" aria-label="name is">
                  <Option value="週">週</Option>
                  <Option value="月">月</Option>
                  <Option value="季">季</Option>
                  <Option value="年">年</Option>
                </Select>
              </Form.Item>
            </div>
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            rules={[
              {
                required: true,
                message: '請勾選工作週期',
              },
            ]}
            label="工作週期"
            name="workDate"
          >
            <Checkbox.Group>
              <Checkbox value="一">星期一</Checkbox>
              <Checkbox value="二">星期二</Checkbox>
              <Checkbox value="三">星期三</Checkbox>
              <Checkbox value="四">星期四</Checkbox>
              <Checkbox value="五">星期五</Checkbox>
              <Checkbox value="六">星期六</Checkbox>
              <Checkbox value="日">星期日</Checkbox>
            </Checkbox.Group>
          </Form.Item>
          <Form.Item
            label="清潔期間"
            name="startDate"
            rules={[
              {
                required: true,
                message: '請選擇維護年度',
              },
            ]}
            {...formItemLayout}
          >
            <RangePicker type="date" />
          </Form.Item>
          <Form.Item
            label="注意事項"
            name="contentText"
            rules={[
              {
                required: true,
                message: '請選擇維護年度',
              },
            ]}
            {...formItemLayout}
          >
            <Input.TextArea placeholder="TextArea" aria-label="TextArea" />
          </Form.Item>
        </Form>
      </Dialog>

      {/* 查看維修記錄 */}

      <Dialog
        hasMask
        className={styles.dialog}
        visible={cleanRecordDialog}
        onOk={() => {
          setCleanRecordDialog(false);
        }}
        onCancel={() => {
          setCleanRecordDialog(false);
        }}
        onClose={() => {
          setCleanRecordDialog(false);
        }}
      >
        <h1>查看本次清潔記錄</h1>
        <Button
          type="normal"
          onClick={() => setCleanRecordAddDialog(true)}
          style={{ marginBottom: '20px' }}
        >
          新增清潔記錄
        </Button>
        <Table dataSource={cleanUpdate.workRecord}>
          <Table.Column
            dataIndex="createdTime"
            title="建立時間"
            cell={(value) => moment(value).format('YYYY-MM-DD')}
          />

          <Table.Column dataIndex="cleanRecordText" title="清潔記錄" />
          <Table.Column dataIndex="cleanRecordPerson" title="維護人員" />
        </Table>
      </Dialog>

      {/* 新增編輯維修記錄 */}
      <Dialog
        name="dynamic_form_item"
        hasMask
        className={styles.dialog}
        visible={cleanRecordAddDialog}
        onOk={() => {
          form1.submit();
        }}
        onCancel={() => {
          setCleanRecordAddDialog(false);
        }}
        onClose={() => {
          setCleanRecordAddDialog(false);
        }}
      >
        <h1>新增清潔記錄</h1>
        <Form
          form={form1}
          onFinish={onFinishRecord}
          {...formItemLayoutWithOutLabel}
        >
          <Form.Item
            label="清潔記錄"
            name="cleanRecordText"
            rules={[
              {
                required: false,
                message: '請輸入維修原因',
              },
            ]}
            {...formItemLayout}
          >
            <Input.TextArea />
          </Form.Item>

          <Form.Item
            label="清潔人員"
            name="cleanRecordPerson"
            rules={[
              {
                required: true,
                message: '請輸入維護人員',
              },
            ]}
            {...formItemLayout}
          >
            <Input />
          </Form.Item>
        </Form>
      </Dialog>

      <br />
      <br />
      <Card free>
        <Card.Content>
          <Table dataSource={cleanData}>
            <Table.Column title="項目名稱" width={150} dataIndex="name" />

            <Table.Column
              title="清潔工作週期"
              dataIndex="cycle"
              width={150}
              cell={(value, _index, record) => {
                const check = value.split('');
                return (
                  <>
                    每{check[0]}
                    {check[1]}
                    {record.workDate.join(',')}
                  </>
                );
              }}
            />
            <Table.Column
              title="清潔期間"
              width={200}
              cell={(_value, _index, record) =>
                `${moment(record.startDate).format('YYYY/MM/DD')}至${moment(
                  record.endDate
                ).format('YYYY/MM/DD')}`
              }
            />
            <Table.Column
              title="操作"
              width={100}
              cell={(_value, _index, record) => {
                if (record.workRecord.length === 0) {
                  return (
                    <div className={styles.btnGroup}>
                      <Button
                        type="primary"
                        onClick={() => {
                          setCleanUpdate(record);
                          setCleanRecordDialog(true);
                        }}
                      >
                        查看清潔記錄
                      </Button>

                      <Button
                        type="normal"
                        onClick={() => {
                          setCommunityDeviceStatus('update');
                          setCleanUpdate(record);
                          setCleanDialog(true);
                          form.setFieldsValue({
                            ...record,
                            startDate: [
                              moment(record.startDate),
                              moment(record.endDate),
                            ],
                          });
                        }}
                      >
                        編輯
                      </Button>
                      <Button
                        type="primary"
                        onClick={() => {
                          clean
                            .remove(record._id)
                            .then(() => {
                              Message.success('刪除成功');
                              setIsUpdate((pre) => !pre);
                            })
                            .catch((error) => console.log(error));
                        }}
                        warning
                      >
                        刪除
                      </Button>
                    </div>
                  );
                } else {
                  return (
                    <div className={styles.btnGroup}>
                      <Button
                        type="primary"
                        onClick={() => {
                          setCleanUpdate(record);
                          setCleanRecordDialog(true);
                        }}
                      >
                        查看清潔記錄
                      </Button>
                    </div>
                  );
                }
              }}
            />
          </Table>
        </Card.Content>
      </Card>
    </>
  );
};

export default CleanPlanList;
